module.exports = __webpack_public_path__ + "img/baomingbtn.b6e54d42.png";